export default __webpack_public_path__ + "static/media/logo-mobile4x.10b8c709.png";